import { ApiResult, HttpClient } from "../http.js";
import { KlsDeviationDto, KlsDeviationCategory, KlsDeviationSeverity, KlsDeviationStatus } from "../types/kls-deviations.js";

export interface CreateKlsDeviationPayload {
  projectId?: string | null;
  projectTitle?: string | null;
  assignmentId?: string | null;
  assignmentTitle?: string | null;
  inspectionId?: string | null;
  reportedById: string;
  reportedByName: string;
  reportedAt: string;
  title: string;
  description: string;
  category: KlsDeviationCategory;
  severity: KlsDeviationSeverity;
  status: KlsDeviationStatus;
  correctiveAction?: string | null;
  preventiveAction?: string | null;
  rootCause?: string | null;
  resolvedById?: string | null;
  resolvedByName?: string | null;
  resolvedAt?: string | null;
  resolutionNotes?: string | null;
  verifiedById?: string | null;
  verifiedByName?: string | null;
  verifiedAt?: string | null;
  photos?: string[] | null;
  dueDate?: string | null;
  location?: string | null;
  id?: string;
}

export interface UpdateKlsDeviationPayload {
  projectId?: string | null;
  projectTitle?: string | null;
  assignmentId?: string | null;
  assignmentTitle?: string | null;
  inspectionId?: string | null;
  reportedById: string;
  reportedByName: string;
  reportedAt: string;
  title: string;
  description: string;
  category: KlsDeviationCategory;
  severity: KlsDeviationSeverity;
  status: KlsDeviationStatus;
  correctiveAction?: string | null;
  preventiveAction?: string | null;
  rootCause?: string | null;
  resolvedById?: string | null;
  resolvedByName?: string | null;
  resolvedAt?: string | null;
  resolutionNotes?: string | null;
  verifiedById?: string | null;
  verifiedByName?: string | null;
  verifiedAt?: string | null;
  photos?: string[] | null;
  dueDate?: string | null;
  location?: string | null;
}

export interface ListKlsDeviationsQuery {
  projectId?: string;
  status?: KlsDeviationStatus;
}

export class KlsDeviationsApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListKlsDeviationsQuery = {}): Promise<ApiResult<KlsDeviationDto[]>> {
    return this.http.get<KlsDeviationDto[]>("/api/kls-deviations", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<KlsDeviationDto>> {
    return this.http.get<KlsDeviationDto>(`/api/kls-deviations/${encodeURIComponent(id)}`);
  }

  create(payload: CreateKlsDeviationPayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/kls-deviations", { body: payload });
  }

  update(id: string, payload: UpdateKlsDeviationPayload): Promise<ApiResult<KlsDeviationDto>> {
    return this.http.put<KlsDeviationDto>(`/api/kls-deviations/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/kls-deviations/${encodeURIComponent(id)}`);
  }
}
